"use client";

import { useAuth } from "@/lib/auth";
import type { PlanTier, PlanLimits } from "@/lib/types";

/**
 * Hook for accessing the current user's plan tier and limits.
 * Wraps useAuth() and provides convenience helpers.
 */
export function usePlan() {
  const { user } = useAuth();

  const tier: PlanTier = user?.tier || "free";
  const limits: PlanLimits = user?.tier_limits || ({} as PlanLimits);

  return {
    tier,
    limits,
    isFree: tier === "free",
    isPro: tier === "pro",
    isBusiness: tier === "business",
    isEnterprise: tier === "enterprise",
    isPaid: tier !== "free",
    canUseFeature: (feature: keyof PlanLimits): boolean => {
      const val = limits[feature];
      if (val === undefined || val === null) return false;
      if (typeof val === "boolean") return val;
      return val !== 0;
    },
    getLimit: (key: keyof PlanLimits): number | null => {
      const val = limits[key];
      if (typeof val === "number") return val;
      return null;
    },
  };
}
